export const bookTypes = [
  { label: "Новинки", value: "new" },
  { label: "Бестселери", value: "bestsellers" },
  { label: "Акції", value: "promotions" },
];
